import { FC, useContext } from 'react';
import { Menu } from '@chakra-ui/react';

import {
  ApplicationContext,
  DocumentDetailsViewActionContext,
} from '../../Layout.component';

export const EquifaxMenuItem: FC = () => {
  const { actionContexts } = useContext(ApplicationContext);

  const {
    action: { text, key },
  } = useContext(DocumentDetailsViewActionContext);

  const { modal } = actionContexts[key];

  return (
    <Menu.Item onClick={modal.onOpen} value={`equifax-${key}`}>
      {text}
    </Menu.Item>
  );
};
